import React from 'react';
import PropTypes from 'prop-types';
import classes from './ShimmerLoader.module.scss';

const ShimmerLoader = (props) => {
    const { height, width } = props;
    let customStyle = {};
    if (height || width) {
        customStyle = {
            height: height,
            width: width,
        }
    }
    return (
        <div className={classes.ShimmerLoaderBlock} style={customStyle}></div>
    )
}

ShimmerLoader.propTypes = {
    height: PropTypes.string,
    width: PropTypes.string, 
}

export default ShimmerLoader;
